'use client'

import { useState } from 'react'
import { cn, formatPrice } from '@/lib/utils'

import { Input, ScrollArea } from '@/components/ui'

interface ReportOrderTaxesViewProps {
  items: any[]
}

export const ReportOrderTaxesView = ({ items }: ReportOrderTaxesViewProps) => {
  const [searchQuery, setSearchQuery] = useState('')

  const filteredItems = items?.filter((item) =>
    item?.invoice_number?.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  return (
    <div className="flex h-full w-full flex-col overflow-hidden rounded-lg border border-gray-100 bg-white shadow-card">
      <div className="sticky top-0 flex flex-col gap-4 border-b border-gray-100 bg-white">
        <div className="grid w-full grid-cols-3 items-center overflow-hidden rounded-t-lg bg-gray-50 text-sm font-medium [&>span:last-of-type]:border-r-0 [&>span]:flex [&>span]:h-full [&>span]:w-full [&>span]:items-center [&>span]:justify-end [&>span]:border-r [&>span]:border-gray-100 [&>span]:px-4 [&>span]:py-3">
          <span className="flex items-center !justify-start gap-2 text-left">
            <span>Invoice</span>
            <Input
              placeholder="Filter by Invoice No"
              value={searchQuery}
              onChangeValue={(value) => setSearchQuery(value)}
              className="h-8 w-[200px] rounded-md px-2"
            />
          </span>
          <span>Tax Name</span>
          <span>Tax Amount</span>
        </div>
      </div>

      <ScrollArea className="flex h-full w-full flex-col gap-12">
        <div className="grid w-full bg-white">
          {filteredItems?.map((item) => {
            return (
              <div
                className="grid w-full grid-cols-3 border-b border-gray-100 bg-white text-sm font-medium last:border-b-0 hover:bg-gray-50 [&>span:last-of-type]:border-r-0 [&>span]:flex [&>span]:h-full [&>span]:w-full [&>span]:items-center [&>span]:justify-end [&>span]:border-r [&>span]:border-gray-100 [&>span]:px-4 [&>span]:py-3"
                key={item?.invoice_number}
              >
                <span
                  className={cn(
                    'flex w-full items-center !justify-start text-left',
                  )}
                  key={item?.invoice_number + item?.variant_id}
                >
                  <span className="text-left">{item?.invoice_number}</span>
                </span>
                <span className="text-right">{item?.tax_name}</span>
                <span className="text-right">
                  {formatPrice(Number(item?.tax_amount), 2, false)}
                </span>
              </div>
            )
          })}
        </div>
      </ScrollArea>
    </div>
  )
}
